import React from 'react';
import PropTypes from 'prop-types';

export const ZeroLabel = ( props ) => {
    const { y } = props;
    return (
        <text dx={ 513 } dy={ y + 15 } style={ { fill: '#353a40',
        fontWeight: 400 } }>0</text>
    );
};

ZeroLabel.propTypes = {
    y: PropTypes.number
};

export default ZeroLabel;